type BrandWordmarkProps = {
  /** Header lockup is slightly larger; footer is compact. */
  variant?: "header" | "footer";
  className?: string;
};

/** Text-only wordmark (no separate icon mark yet). */
export function BrandWordmark({
  variant = "header",
  className = "",
}: BrandWordmarkProps) {
  return (
    <span
      className={["wordmark", `wordmark--${variant}`, className]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="wordmark-lockup">
        <span className="wordmark-spec">Spec</span>
        <span className="wordmark-ops">Ops</span>
      </span>
      <span className="wordmark-rule" aria-hidden />
      <span className="wordmark-engineers">Engineers</span>
    </span>
  );
}
